(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/reducers/make-coupon-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/reducers/make-coupon-reducer.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  createReducer,
  isAnyOf
} = RTK;
const {
  createCoupons,
  createPixCoupon
} = svs.components.tipsen.engine;
const {
  clearCoupon,
  clearCouponBoard,
  toggleAlternative,
  setExternalCoupon,
  selectBetAmount,
  setSportkryssFactorIndex,
  setSportkryssNumber,
  selectWeek,
  selectPixSize,
  placeBet,
  resetWithCouponValues,
  selectSystem,
  toggleMSign,
  generateXpertCoupon,
  generateSportPixCoupon,
  setCouponValues,
  setSignDistribution,
  setReduceModeCount
} = svs.components.tipsen.engine.actions;
const {
  COUPON_EXTERNAL_SYSTEM,
  COUPON_XPERT
} = svs.components.tipsen.engine.constants.couponTypes;
const {
  SYSTEM_USYS,
  SYSTEM_MSYS
} = svs.components.tipsen.engine.constants.systems;
const {
  BOARD_MULTIPLE,
  BOARD_SINGLE
} = svs.components.tipsen.engine.constants.boardType;
const {
  QUICKPICK_WEIGHTED,
  QUICKPICK_PARTIAL,
  QUICKPICK_MODIFIED
} = svs.components.tipsen.engine.constants.quickpickProp;
const {
  loadOpenedDrawsByEngine,
  loadDrawsLite
} = svs.components.sport.drawsRedux.actions;
const definitions = svs.components.tipsen.engine.definitions;
const {
  relatedTypes
} = svs.components.sport.drawsRedux.constants;
const {
  products
} = svs.utils;

const resetCoupon = _ref => {
  let {
    state,
    couponId,
    keepUserSigns = false,
    resetFullCoupon = false,
    sportkryssNumber,
    reduceModeCount,
    betAmountIndex
  } = _ref;
  for (const board of state[couponId].boards) {
    board.pixSize = null;
    board.pixVariant = null;
    if (!keepUserSigns) {
      for (const row of board.userSigns) {
        for (let i = 0; i < row.length; ++i) {
          row[i] = false;
        }
      }
    }
    for (const row of board.signs) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = false;
      }
    }
    for (const row of board.signDistribution) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = 0;
      }
    }
    for (let i = 0; i < board.mSigns.length; ++i) {
      board.mSigns[i] = false;
    }
    for (let i = 0; i < board.uSigns.length; ++i) {
      board.uSigns[i] = null;
    }
  }
  if (resetFullCoupon) {
    state[couponId].betAmountIndex = betAmountIndex !== null && betAmountIndex !== void 0 ? betAmountIndex : 0;
    state[couponId].week = 0;
    state[couponId].sportkryss = 0;
    state[couponId].sportkryssNumber = sportkryssNumber;
    state[couponId].selectedSystem = 0;
    state[couponId].rSystem = null;
    state[couponId].uSystem = null;
    state[couponId].reduceModeCount = reduceModeCount;
  }
  state[couponId].xpertAnalysisAuthorId = null;
};
const resetCouponBoard = _ref2 => {
  let {
    state,
    couponId,
    boardIndex,
    keepUserSigns
  } = _ref2;
  const board = state[couponId].boards[boardIndex];
  if (board) {
    board.pixSize = null;
    board.pixVariant = null;
    if (!keepUserSigns) {
      for (const row of board.userSigns) {
        for (let i = 0; i < row.length; ++i) {
          row[i] = false;
        }
      }
    }
    for (const row of board.signs) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = false;
      }
    }
    for (const row of board.signDistribution) {
      for (let i = 0; i < row.length; ++i) {
        row[i] = 0;
      }
    }
    for (let i = 0; i < board.mSigns.length; ++i) {
      board.mSigns[i] = false;
    }
    for (let i = 0; i < board.uSigns.length; ++i) {
      board.uSigns[i] = null;
    }
  }
  const _selectCouponEmpty = () => {
    for (const board of state[couponId].boards) {
      for (const row of board.signs) {
        if (row.includes(true)) {
          return false;
        }
      }
    }
    return true;
  };
  if (_selectCouponEmpty()) {
    state[couponId].xpertAnalysisAuthorId = null;
  }
};
const helperGetSigns = (state, _ref3) => {
  var _state$couponId$board, _state$couponId, _state$couponId$board2;
  let {
    couponId,
    board,
    event
  } = _ref3;
  return (_state$couponId$board = (_state$couponId = state[couponId]) === null || _state$couponId === void 0 ? void 0 : (_state$couponId$board2 = _state$couponId.boards[board]) === null || _state$couponId$board2 === void 0 ? void 0 : _state$couponId$board2.signs[event]) !== null && _state$couponId$board !== void 0 ? _state$couponId$board : null;
};
const helperGetMSign = (state, _ref4) => {
  var _state$couponId$board3, _state$couponId2, _state$couponId2$boar;
  let {
    couponId,
    board,
    event
  } = _ref4;
  return (_state$couponId$board3 = (_state$couponId2 = state[couponId]) === null || _state$couponId2 === void 0 ? void 0 : (_state$couponId2$boar = _state$couponId2.boards[board]) === null || _state$couponId2$boar === void 0 ? void 0 : _state$couponId2$boar.mSigns[event]) !== null && _state$couponId$board3 !== void 0 ? _state$couponId$board3 : null;
};
const helperToggleMSign = (state, _ref5) => {
  let {
    couponId,
    board,
    event
  } = _ref5;
  state[couponId].boards[board].mSigns[event] = !helperGetMSign(state, {
    couponId,
    board,
    event
  });
};
const makeCouponReducer = coupons => createReducer(coupons, builder => {
  builder.addCase(setExternalCoupon, (state, action) => {
    const {
      productId,
      drawId,
      boards,
      betAmountIndex,
      totalPrice,
      totalAmountOfRows,
      guid
    } = action.payload;
    const couponId = "".concat(productId, "_").concat(drawId, "_").concat(COUPON_EXTERNAL_SYSTEM);
    state[couponId].boards = [...boards];
    state[couponId].betAmountIndex = betAmountIndex;
    state[couponId].totalPrice = totalPrice;
    state[couponId].totalAmountOfRows = totalAmountOfRows;
    state[couponId].guid = guid;
  }).addCase(toggleAlternative, (state, action) => {
    const {
      couponId,
      boardIndex,
      event,
      outcome,
      systemType
    } = action.payload;
    const board = state[couponId].boards[boardIndex];
    if (!board) {
      return;
    }
    const isUSystem = systemType === SYSTEM_USYS;
    const isSelected = board.signs[event][outcome] === true;
    const hasMoreThanOneSelection = board.signs[event].filter(sign => sign).length > 1;
    const hasNoUSign = board.uSigns[event] === null;
    const hasNoMSign = board.mSigns[event] === false;
    const {
      type
    } = board;
    if (isUSystem && isSelected && hasMoreThanOneSelection && hasNoUSign && hasNoMSign) {
      board.uSigns[event] = outcome;
    } else {
      const currentSign = helperGetSigns(state, {
        couponId,
        board: boardIndex,
        event
      })[outcome];
      const newSign = !currentSign;
      if (type === BOARD_SINGLE) {
        for (let i = 0; i < board.signs[event].length; ++i) {
          board.signs[event][i] = false;
        }
        for (let i = 0; i < board.userSigns[event].length; ++i) {
          board.userSigns[event][i] = false;
        }
      } else if (type !== BOARD_MULTIPLE) {
        throw new Error("Unknown board type: ".concat(type));
      }
      board.uSigns[event] = null;
      board.signs[event][outcome] = newSign;
      board.userSigns[event][outcome] = board.signs[event][outcome];
      state[couponId].xpertAnalysisAuthorId = null;
      if (currentSign) {
        board.signDistribution[event][outcome] = 0;
      }
      const totalSigns = board.signs[event].length;
      const totalToggledSigns = board.signs[event].filter(sign => sign).length;
      const ratio = totalToggledSigns / totalSigns;
      for (let i = 0; i < board.signDistribution[event].length; ++i) {
        if (board.signs[event][i]) {
          board.signDistribution[event][i] = ratio;
        }
      }
    }
    if ([QUICKPICK_PARTIAL, QUICKPICK_WEIGHTED].indexOf(board.pixVariant) !== -1) {
      board.pixVariant = QUICKPICK_MODIFIED;
    }
    const mSign = helperGetMSign(state, {
      couponId,
      board: boardIndex,
      event
    });
    if (mSign) {
      const activeSigns = helperGetSigns(state, {
        couponId,
        board: boardIndex,
        event
      }).filter(sign => sign);
      if (activeSigns.length < 2) {
        helperToggleMSign(state, {
          couponId,
          board: boardIndex,
          event
        });
      }
    }
  }).addCase(setSignDistribution, (state, action) => {
    const {
      couponId,
      board,
      event,
      distributions
    } = action.payload;
    state[couponId].boards[board].signDistribution[event] = distributions;
  }).addCase(selectBetAmount, (state, action) => {
    state[action.payload.couponId].betAmountIndex = action.payload.betAmountIndex;
  }).addCase(setSportkryssFactorIndex, (state, action) => {
    state[action.payload.couponId].sportkryss = action.payload.sportkryssFactorIndex;
  }).addCase(setSportkryssNumber, (state, action) => {
    const {
      couponId,
      sportkryssNumber
    } = action.payload;
    state[couponId].sportkryssNumber = sportkryssNumber;
  }).addCase(clearCoupon, (state, action) => {
    const {
      couponId
    } = action.payload;
    resetCoupon({
      state,
      couponId
    });
  }).addCase(clearCouponBoard, (state, action) => {
    const {
      couponId,
      boardIndex
    } = action.payload;
    resetCouponBoard({
      state,
      couponId,
      boardIndex
    });
  }).addCase(selectWeek, (state, action) => {
    state[action.payload.couponId].week = action.payload.week;
  }).addCase(selectPixSize, (state, action) => {
    const {
      couponId
    } = action.payload;
    state[couponId].selectedAddonPixIndex = action.payload.addonPixChoice;
    resetCoupon({
      state,
      couponId
    });
  }).addCase(loadDrawsLite.fulfilled, (state, action) => {
    const {
      relatedProductId,
      type
    } = action.meta.arg;
    const productName = products.getProductClassName(relatedProductId);
    const engineDefinition = definitions[productName];
    for (const drawId of action.payload.Draws.ids) {
      if (type !== relatedTypes.PIX) {
        break;
      }
      const _draw = action.payload.Draws.entities[drawId];
      const draw = {
        productId: _draw.productId,
        drawNumber: _draw.drawNumber,
        sportType: 1,
        drawEvents: new Array(13).fill(null)
      };
      const drawNumber = action.payload.Draws.entities[drawId].drawNumber;
      const newCoupon = createPixCoupon({
        draw,
        engineDefinition
      });
      const oldCoupon = state["".concat(relatedProductId, "_").concat(drawNumber, "_").concat(COUPON_XPERT)] || {};
      state["".concat(relatedProductId, "_").concat(drawNumber, "_").concat(COUPON_XPERT)] = _objectSpread(_objectSpread({}, newCoupon), oldCoupon);
    }
  }).addCase(selectSystem, (state, action) => {
    var _action$payload$rSyst, _action$payload$uSyst;
    state[action.payload.couponId].selectedSystem = action.payload.system;
    state[action.payload.couponId].rSystem = (_action$payload$rSyst = action.payload.rSystem) !== null && _action$payload$rSyst !== void 0 ? _action$payload$rSyst : state[action.payload.couponId].rSystem;
    state[action.payload.couponId].uSystem = (_action$payload$uSyst = action.payload.uSystem) !== null && _action$payload$uSyst !== void 0 ? _action$payload$uSyst : state[action.payload.couponId].uSystem;
    if (action.payload.system !== action.payload.systemTypes.indexOf(SYSTEM_MSYS)) {
      state[action.payload.couponId].lastSelectedSystemType = action.payload.system;
    }
  }).addCase(toggleMSign, (state, action) => {
    const {
      couponId,
      board,
      event
    } = action.payload;
    helperToggleMSign(state, {
      couponId,
      board,
      event
    });
    state[couponId].boards[board].uSigns[event] = null;
    state[couponId].xpertAnalysisAuthorId = null;
  }).addCase(setReduceModeCount, (state, action) => {
    state[action.payload.couponId].reduceModeCount = action.payload.value;
  }).addCase(loadOpenedDrawsByEngine.fulfilled, (state, action) => _objectSpread(_objectSpread({}, createCoupons({
    engineDefinition: action.meta.arg,
    draws: action.payload.Draws.entities
  })), state)).addMatcher(isAnyOf(generateXpertCoupon.fulfilled, generateSportPixCoupon.fulfilled), (state, action) => {
    const {
      couponId,
      boardSigns,
      overwriteCoupon = true,
      keepUserSigns,
      rSystem,
      system,
      xpertAnalysisAuthorId
    } = action.payload;
    if (overwriteCoupon) {
      resetCoupon({
        state,
        couponId,
        keepUserSigns
      });
    }
    for (const [boardIndex, signs] of Object.entries(boardSigns)) {
      var _action$meta$arg$data, _action$meta, _action$meta$arg, _action$meta$arg$data2;
      if (!overwriteCoupon) {
        resetCouponBoard({
          state,
          couponId,
          keepUserSigns,
          boardIndex
        });
      }
      const board = state[couponId].boards[boardIndex];
      board.signs = signs;
      board.pixSize = (_action$meta$arg$data = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : (_action$meta$arg = _action$meta.arg) === null || _action$meta$arg === void 0 ? void 0 : (_action$meta$arg$data2 = _action$meta$arg.data) === null || _action$meta$arg$data2 === void 0 ? void 0 : _action$meta$arg$data2.system) !== null && _action$meta$arg$data !== void 0 ? _action$meta$arg$data : null;
      for (let eventIndex = 0; eventIndex < board.signs.length; ++eventIndex) {
        const totalSigns = board.signs[eventIndex].length;
        const totalToggledSigns = board.signs[eventIndex].filter(sign => sign).length;
        const ratio = totalToggledSigns / totalSigns;
        for (let k = 0; k < board.signDistribution[eventIndex].length; ++k) {
          if (board.signs[eventIndex][k]) {
            board.signDistribution[eventIndex][k] = ratio;
          }
        }
      }
      const hasUserSigns = Array.isArray(board.userSigns) && board.userSigns.some(userSignRow => Array.isArray ? userSignRow.includes(true) : userSignRow);
      board.pixVariant = hasUserSigns ? QUICKPICK_PARTIAL : QUICKPICK_WEIGHTED;
    }
    state[couponId].xpertAnalysisAuthorId = xpertAnalysisAuthorId;
    if (typeof system === 'number') {
      state[couponId].selectedSystem = system;
    }
    if (typeof rSystem === 'number') {
      state[couponId].rSystem = rSystem;
    }
  }).addMatcher(isAnyOf(placeBet.fulfilled, resetWithCouponValues), (state, action) => {
    var _action$meta2, _engineDefinition$def;
    const {
      couponId,
      reduceModeCount,
      sportkryssNumber
    } = action.payload;
    const {
      relatedCouponId,
      productId
    } = ((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.arg) || {};
    const isExternal = couponId.includes(COUPON_EXTERNAL_SYSTEM);
    const productName = products.getProductClassName(productId);
    const engineDefinition = definitions[productName];
    const betAmountIndex = engineDefinition === null || engineDefinition === void 0 ? void 0 : (_engineDefinition$def = engineDefinition.defaultCouponValues) === null || _engineDefinition$def === void 0 ? void 0 : _engineDefinition$def.betAmountIndex;
    if (isExternal) {
      state[couponId].boards = [];
    } else {
      if (relatedCouponId) {
        state[relatedCouponId].selectedAddonPixIndex = 0;
        resetCoupon({
          state,
          couponId: relatedCouponId,
          resetFullCoupon: true,
          sportkryssNumber,
          reduceModeCount,
          betAmountIndex
        });
      }
      resetCoupon({
        state,
        couponId,
        resetFullCoupon: true,
        sportkryssNumber,
        reduceModeCount,
        betAmountIndex
      });
    }
  }).addMatcher(isAnyOf(setCouponValues, resetWithCouponValues), (state, action) => {
    const {
      week,
      betAmountIndex,
      sportkryss,
      sportkryssNumber,
      signs,
      systemType,
      rSystem,
      uSystem,
      couponId
    } = action.payload;
    if (week !== undefined) {
      state[couponId].week = week;
    }
    if (betAmountIndex !== undefined) {
      state[couponId].betAmountIndex = betAmountIndex;
    }
    if (sportkryss !== undefined) {
      state[couponId].sportkryss = sportkryss;
    }
    if (sportkryssNumber) {
      state[couponId].sportkryssNumber = sportkryssNumber;
    }
    for (let boardIndex = 0; boardIndex < Math.min(signs.length, state[couponId].boards.length); ++boardIndex) {
      state[couponId].boards[boardIndex].signs = state[couponId].boards[boardIndex].signs.map((element, index) => {
        if (signs[boardIndex].signs[index]) {
          return signs[boardIndex].signs[index];
        }
        return element;
      });

      if (signs[boardIndex].mSigns) {
        for (let x = 0; x < signs[boardIndex].mSigns.length; ++x) {
          const activeSigns = helperGetSigns(state, {
            couponId,
            board: boardIndex,
            event: x
          }).filter(sign => sign);
          let mSign = signs[boardIndex].mSigns[x];

          if (activeSigns.length < 2 && mSign) {
            mSign = false;
          }
          state[couponId].boards[boardIndex].mSigns[x] = mSign;
        }
      }

      state[couponId].boards[boardIndex].userSigns = state[couponId].boards[boardIndex].signs;
      state[couponId].boards[boardIndex].signDistribution = state[couponId].boards[boardIndex].signs.map(r => r.map(s => s ? 1 : 0));

      if (signs[boardIndex].uSigns) {
        state[couponId].boards[boardIndex].uSigns = signs[boardIndex].uSigns;
      }
    }
    if (typeof systemType !== 'undefined') {
      state[couponId].lastSelectedSystemType = systemType;
      state[couponId].selectedSystem = systemType;
      state[couponId].rSystem = rSystem;
      state[couponId].uSystem = uSystem;
    }
  });
});
setGlobal('svs.components.tipsen.engine.reducers.makeCouponReducer', makeCouponReducer);
 })(window);